import Component from '@glimmer/component'
import { KidsSafe } from 'teacher-ui-client/components/footer-main/kids-safe'
import { ScrollToTop } from 'teacher-ui-client/components/footer-main/scroll-to-top'
import { Partner } from 'teacher-ui-client/components/footer-main/partner'
import { SocialLinks } from 'teacher-ui-client/components/footer-main/social-links'
import { FooterNav } from 'teacher-ui-client/components/footer-main/nav'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { Copyright } from 'teacher-ui-client/components/footer-main/copyright'

const privacyUrls: Record<string, string> = {
  US: 'https://readingeggs.com/privacy',
  CA: 'https://readingeggs.com/privacy',
  KR: 'https://readingeggs.com/privacy',
}

const aboutUrls: Record<string, string> = {
  CA: 'https://mathseeds.ca/schools/about-us',
  US: 'https://mathseeds.com/schools/about-us',
  NZ: 'https://mathseeds.co.nz/schools/about-us',
  KR: 'https://www.abceggs.co.kr/',
  CN: 'https://mathseeds.com/schools/about-us',
}

interface Signature {
  Element: HTMLElement
  Args: {
    countryCode: string
  }
}

export class FooterMaths extends Component<Signature> {
  get aboutUrl() {
    return aboutUrls[this.args.countryCode] ?? 'https://mathseeds.com.au/schools/about-us'
  }

  get privacyUrl() {
    return privacyUrls[this.args.countryCode] ?? 'https://readingeggs.com.au/privacy'
  }

  <template>
    <footer class="footer-main-bg-image-maths bg-rexy-purple-300 flex flex-none pt-3 pb-2 print:hidden" ...attributes>

      <div class="w-1/4 text-right">
        <SocialLinks @subscriptionType={{SubscriptionType.Maths}} @countryCode={{@countryCode}} />
        <Partner @subscriptionType={{SubscriptionType.Maths}} />
      </div>

      <div class="w-1/2 text-center">
        <FooterNav @aboutUrl={{this.aboutUrl}} @privacyUrl={{this.privacyUrl}} />

        <Copyright class="mt-3" @subscriptionType={{SubscriptionType.Maths}} />
      </div>

      <div class="w-1/4 text-left">
        <ScrollToTop class="mb-2" />

        <KidsSafe />
      </div>
    </footer>
  </template>
}

export default FooterMaths
